import AppLayout from "@/layouts/AppLayout.vue";
import LegalDocumentListView from "@/views/legalDocument/LegalDocumentListView.vue";

export default [
  {
    path: '/legal-documents',
    name: 'legalDocuments',
    component: LegalDocumentListView,
    meta: {
      parent: 'legal',
      related: 'legalDocuments',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['GET_LEGAL_DOCUMENT']
    }
  },
];
